import type { PriceBreakdown } from '@/scopes/prices/domain/transports/types'
import type { PriceBreakdown as ApiPriceBreakdown } from './types'

export function mapPriceBreakdown(apiPriceBreakdown: ApiPriceBreakdown, pricePerPerson: number): PriceBreakdown {
  const rooms = apiPriceBreakdown.rooms?.map(room =>
    room.map(profile => ({
      price: profile.rawAmount,
      valueText: profile.text,
      description: profile.value,
      isDiscount: false,
    })),
  ) || []
  return {
    atReservation: {
      rooms,
      services: apiPriceBreakdown.services?.map(service => ({
        header: service.text,
        price: service.rawAmount,
        valueText: service.value,
        description: '',
        isDiscount: service.isDiscount,
      })) || [],
      subtotal: apiPriceBreakdown.subTotalPayAtReservation?.raw || 0,
    },
    atDestination: {
      items: apiPriceBreakdown.localCostsWithPrice?.map(localCost => ({
        header: localCost.name,
        price: localCost.price.raw,
        valueText: '',
        description: localCost.description,
        isDiscount: false,
      })) || [],
      subtotal: apiPriceBreakdown.subTotalPayAtDestination?.raw || 0,
    },
    totalPrice: apiPriceBreakdown.totalPrice?.raw || 0,
    totalGrossPrice: apiPriceBreakdown.totalGrossPrice?.raw || 0,
    extraCostsText: apiPriceBreakdown.localCostsWithoutPrice?.map(localCost => ({
      title: localCost.name,
      text: localCost.description,
    }))?.[0],
    pricePerPerson,
    usps:
      apiPriceBreakdown.usps?.slice(0, 3).map(usp => ({
        type: usp.kind,
        title: usp.title,
        text: usp.subtitle,
      })) || [],
    countDown: apiPriceBreakdown?.countdown,
  }
}
